export default "__VITE_ASSET__Bk6qDzTV__"